import type { ElTooltipProps, FormProps } from 'element-plus'
import { EEntities } from '@/types/enums'

export default defineNuxtPlugin(() => {
  const { public: { NUXT_ENV, NUXT_APP_VERSION } } = useRuntimeConfig()

  return {
    provide: {
      appVersion: `v${NUXT_APP_VERSION}`,
      appEnv: {
        env: NUXT_ENV as 'production' | 'staging' | 'development',
        isProduction: NUXT_ENV === 'production',
        isStaging: NUXT_ENV === 'staging',
        isDev: !['production', 'staging'].includes(NUXT_ENV)
      },
      entities: EEntities,
      elFormDefault: {
        labelPosition: 'top',
        requireAsteriskPosition: 'right'
      } as Pick<FormProps, 'labelPosition' | 'requireAsteriskPosition'>,
      elTooltipDefault: {
        hideAfter: 0,
        placement: 'top',
        effect: 'light'
      } as Pick<ElTooltipProps, 'hideAfter' | 'placement' | 'effect'>
    }
  }
})
